// Hook for accessing and filtering Gitcha's available cities in search dropdowns
import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAppConfig } from "@/appConfig";
import { fetchAllAvailableCities } from "../actions/locations";
import {
  filterAvailableCities,
  getFeaturedCities,
} from "../constants/cityConfig";

const useAvailableCities = () => {
  const dispatch = useDispatch();
  const { tenant } = useAppConfig();
  const allCities = useSelector((state) => state.locations.allCities);
  const allCitiesLoaded = useSelector(
    (state) => state.locations.allCitiesLoaded
  );

  useEffect(() => {
    if (!allCitiesLoaded && allCities.length === 0) {
      dispatch(fetchAllAvailableCities());
    }
  }, [dispatch, allCitiesLoaded, allCities.length]);

  const filterCities = useCallback(
    (query) => filterAvailableCities(allCities, query),
    [allCities]
  );

  // Featured cities for showing on focus (before typing). BLS tenants surface
  // their own primary market (from tenant config); default Gitcha uses the
  // standard featured cities.
  const featuredCities = getFeaturedCities(tenant?.locationRestriction).map(
    (fc) => ({
      ...fc,
      isFeatured: true,
    })
  );

  return { allCities, featuredCities, filterCities, allCitiesLoaded };
};

export default useAvailableCities;
